import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarDominioMapaCalor from '../../components/modal/ModalCadastrarDominioMapaCalor';
import ModalEditarDominioMapaCalor from '../../components/modal/ModalEditarDominioMapaCalor';
import ModalExcluirDominioMapaCalor from '../../components/modal/ModalExcluirDominioMapaCalor';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function DominioMapaCalor() {
    const { Success, Error, openModal, setOpenModal, DominioMapaCalorConsulta, ListaDominioMapaCalorConsulta, modalEditarDominioMapaCalor, setModalEditarDominioMapaCalor, setEdicaoDominioMapaCalor, setDominioMapaCalorAtualKey, modalExcluirDominioMapaCalor, setModalExcluirDominioMapaCalor, InativarDominioMapaCalor, Loading, ListaFiltroDominioMapaCalor, totalRegistrosDominioMapaCalor, filtroDominioMapaCalor, totalRegistrosFiltroDominioMapaCalor, Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditDominioMapaCalor = (props) => {
        setModalEditarDominioMapaCalor(true)
        setDominioMapaCalorAtualKey(props.key)
        setEdicaoDominioMapaCalor(props)
    }

    const DeletarDominioMapaCalor = (props) => {
        setDominioMapaCalorAtualKey(props.key)
        setModalExcluirDominioMapaCalor(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroDominioMapaCalor(searchTerm, currentPage, pageSize);
        } else {
            ListaDominioMapaCalorConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroDominioMapaCalor : totalRegistrosDominioMapaCalor;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar Domínio do Mapa de Calor'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarDominioMapaCalor &&
                <ModalEditarDominioMapaCalor currentPage={currentPage} />
            }
            {modalExcluirDominioMapaCalor &&
                <ModalExcluirDominioMapaCalor currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {Loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarDominioMapaCalor closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar Domínio do Mapa de Calor</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Domínios do Mapa de Calor cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroDominioMapaCalor : DominioMapaCalorConsulta}
                        columns={[
                            { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                            {
                                label: "Cor",
                                width: "30%",
                                render: (x) => (
                                    <div className="item-ativo" style={{ color: x.corHexadecimal }}>⬤</div>
                                ),
                            },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarDominioMapaCalor(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditDominioMapaCalor(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarDominioMapaCalor(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={Loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroDominioMapaCalor(term, 1, 10);
                            } else {
                                ListaDominioMapaCalorConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default DominioMapaCalor;